import { render, staticRenderFns } from "./DetailsStep.vue?vue&type=template&id=76e99b0b"
import script from "./DetailsStep.vue?vue&type=script&lang=ts"
export * from "./DetailsStep.vue?vue&type=script&lang=ts"
import style0 from "./DetailsStep.vue?vue&type=style&index=0&id=76e99b0b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports